"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationModalConfirmButton = exports.ConfirmationModalCancelButton = exports.ConfirmationModal = void 0;

require("./ConfirmationModal.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _Modal = _interopRequireDefault(require("../../../components/common/Modal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _ActionRoot = require("../../../higher-order/ActionRoot");

var _class, _class2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var ConfirmationModalCancelButton = function ConfirmationModalCancelButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      className = _ref.className;
  var classes = (0, _classnames.default)("cancel-button", className);
  return /*#__PURE__*/_react.default.createElement("button", {
    className: classes,
    onClick: onClick
  }, label);
};

exports.ConfirmationModalCancelButton = ConfirmationModalCancelButton;

var ConfirmationModalConfirmButton = function ConfirmationModalConfirmButton(_ref2) {
  var onClick = _ref2.onClick,
      label = _ref2.label,
      className = _ref2.className,
      disabled = _ref2.disabled;
  var classes = (0, _classnames.default)("confirm-button", className);
  return /*#__PURE__*/_react.default.createElement("button", {
    disabled: disabled,
    className: classes,
    onClick: onClick
  }, label);
};

exports.ConfirmationModalConfirmButton = ConfirmationModalConfirmButton;

var ConfirmationModal = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfirmationModal, _React$Component);

  var _super = _createSuper(ConfirmationModal);

  function ConfirmationModal() {
    _classCallCheck(this, ConfirmationModal);

    return _super.apply(this, arguments);
  }

  _createClass(ConfirmationModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!(0, _isUndefined.default)(document)) {
        document.addEventListener("keyup", this.handleEscape);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!(0, _isUndefined.default)(document)) {
        document.removeEventListener("keyup", this.handleEscape);
      }
    }
  }, {
    key: "handleEscape",
    value: function handleEscape(e) {
      if (e.which === 27
      /* esc */
      ) {
        this.handleCancel(e);
      }
    }
  }, {
    key: "handleCancel",
    value: function handleCancel(e) {
      this.props.dispatcher.emit("CANCEL_CONFIRMATION_MODAL");
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm(e) {
      this.props.dispatcher.emit("CONFIRM_CONFIRMATION_MODAL");
    }
  }, {
    key: "renderDefaultButtons",
    value: function renderDefaultButtons() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.model.hasCallbacks && !this.props.model.hideCancelButton && /*#__PURE__*/_react.default.createElement(ConfirmationModalCancelButton, {
        onClick: this.handleCancel,
        label: this.props.model.cancelLabel
      }), /*#__PURE__*/_react.default.createElement(ConfirmationModalConfirmButton, {
        disabled: this.props.model.customForm && !this.props.model.customForm.canSubmit,
        onClick: this.handleConfirm,
        label: this.props.model.confirmLabel,
        className: this.props.model.confirmClassName
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var model = this.props.model;
      var modalClasses = (0, _classnames.default)("confirmation-modal", model.modalClassName);
      return /*#__PURE__*/_react.default.createElement(_Modal.default, {
        modalKey: "confirmationModal",
        title: "Confirm",
        hideHeader: true,
        allowScrollBar: true,
        isOpen: model.isOpen,
        shouldCloseOnOverlayClick: false,
        className: modalClasses
      }, !(0, _isEmpty.default)(model.title) && /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, model.title, this.props.hideCloseButton && /*#__PURE__*/_react.default.createElement("button", {
        className: "modal-close-button",
        onClick: this.handleCancel
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-cancel-thin"
      }))), (0, _isEmpty.default)(model.title) && (0, _isFunction.default)(model.renderCustomTitle) && /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header"
      }, model.renderCustomTitle()), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, model.message && /*#__PURE__*/_react.default.createElement("div", {
        className: "message"
      }, model.message), (0, _isFunction.default)(model.customRender) && model.customRender(model.customForm)), !model.hideControls && /*#__PURE__*/_react.default.createElement("div", {
        className: "button-container"
      }, (0, _isFunction.default)(model.renderCustomControls) && model.renderCustomControls(this.handleConfirm, model.confirmLabel, this.handleCancel, model.cancelLabel), !(0, _isFunction.default)(model.renderCustomControls) && this.renderDefaultButtons()));
    }
  }]);

  return ConfirmationModal;
}(_react.default.Component), _defineProperty(_class3, "contextType", _ActionRoot.ActionRootContext), _defineProperty(_class3, "propTypes", {
  model: _propTypes.default.shape({
    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    message: _propTypes.default.string,
    customForm: _propTypes.default.object,
    customRender: _propTypes.default.func,
    renderCustomControls: _propTypes.default.func
  })
}), _class3), (_applyDecoratedDescriptor(_class2.prototype, "handleEscape", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleEscape"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleCancel", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleCancel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleConfirm", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleConfirm"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "renderDefaultButtons", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "renderDefaultButtons"), _class2.prototype)), _class2)) || _class;

var propulatedConfirmationModal = (0, _Propulator.default)(ConfirmationModal, {
  messageStore: {
    confirmationModal: "model"
  }
});
exports.ConfirmationModal = propulatedConfirmationModal;